import { render, staticRenderFns } from "./UploadUsers.vue?vue&type=template&id=ef78a272&"
import script from "./UploadUsers.vue?vue&type=script&lang=js&"
export * from "./UploadUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports